<template>
  <div class="w-full max-w-3xl mx-auto">
    <el-form class="space-y-6">
      <!-- Block Name -->
      <el-form-item label="Action Name">
        <el-input v-model="localStep.label" placeholder="Enter Action Name" clearable />
      </el-form-item>

      <!-- Allocation Role -->
      <el-form-item label="Allocation Role *">
        <el-radio-group v-model="localStep.allocationRole" class="pt-1">
          <el-radio label="Assign">Assign</el-radio>
          <el-radio label="Unassign">Unassign</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="isAssign">
        <div class="grid grid-cols-2 gap-5">
          <!-- Allocation Type -->
          <el-form-item label="Allocation Type(Resource) *">
            <el-select
              v-model="localStep.resourceEntity"
              placeholder="Select"
              class="w-full"
              :disabled="true"
            >
              <el-option
                v-for="item in allEntities"
                :key="item._id"
                :value="item._id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Allocation To*">
            <el-select
              v-model="localStep.allocationEntity"
              placeholder="Select"
              class="w-full"
              @change="handleToChange"
            >
              <el-option
                v-for="item in getRelationalEntities"
                :key="item._id"
                :value="item._id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- Exclude Manually Allocated Audience
      <el-form-item label="Exclude Manually Allocated Audience? *">
        <el-select v-model="localStep.excludeManual" placeholder="Select" class="w-full">
          <el-option label="Yes" value="Yes" />
          <el-option label="No" value="No" />
        </el-select>
      </el-form-item> -->

        <!-- Allocate to default -->
        <el-form-item
          :label="'Allocate To (' + (selectedAllocationEntity.name || 'Entity') + ') based on *'"
        >
          <el-select
            v-model="localStep.allocateBasedOn"
            placeholder="Select"
            class="w-full"
            @change="handleAllocateBasedOnChange"
          >
            <el-option
              v-for="item in getAllocationToOptions"
              :key="item._id"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- Select Teams only when Teams selected -->
        <template v-if="localStep.allocateBasedOn">
          <el-form-item :label="'Select ' + allocateBasedOnEntity.name + '(s) to allocate'">
            <el-select
              v-model="localStep.allocateTo"
              :multiple="
                localStep.allocationEntity &&
                selectedAllocationEntity &&
                localStep.allocateBasedOn == localStep.allocationEntity
              "
              placeholder="Please Select Teams"
              class="w-full"
              clearable
              collapse-tags
              filterable
              remote
              :loading="entityFieldLoading"
              loading-text="fetching..."
              :remote-method="(query) => fetchEntityData(query)"
              @clear="fetchEntityData('')"
            >
              <el-option
                v-for="(temp, i) in entitiesData"
                :key="temp._id + i"
                :value="temp._id"
                :label="getLabel(temp, i)"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item
          label="Exclude Filter"
          v-if="
            allocationEntityField &&
            allocationEntityField.allow_multiple &&
            selectedAllocationEntity &&
            selectedAllocationEntity._id &&
            localStep.allocateBasedOn != selectedAllocationEntity._id
          "
        >
          <el-select
            v-model="localStep.excludeFilter"
            placeholder="Select filter to exclude"
            class="w-full"
          >
            <el-option
              v-for="item in entityAllFilters"
              :key="item._id"
              :value="item._id"
              :label="item.filter_name"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- Allocation Method -->
        <el-form-item label="Allocation Method *">
          <el-select v-model="localStep.allocationMethod" placeholder="Select" class="w-full">
            <el-option value="round_robin" label="Round robin" />
          </el-select>
        </el-form-item>

        <el-form-item label="Overwrite existing assignment *">
          <el-checkbox v-model="localStep.overrideAllocation">
            Force reassign (replace existing value if already assigned)
          </el-checkbox>
        </el-form-item>
      </template>
      <template v-if="isUnassign">
        <el-form-item label="UnAllocate Field*">
          <el-select
            v-model="localStep.allocationEntity"
            placeholder="Select"
            class="w-full"
            @change="handleToChange"
          >
            <el-option
              v-for="item in getRelationalEntities"
              :key="item._id"
              :value="item._id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import EntitiesHelper from '../../../../mixins/EntitiesHelper';
  import CustomDashboardHelper from '../../../../mixins/CustomDashboardHelper';
  import { fetchEntityRelationships } from '../../../../repo/entityRelationshipsRepo';

  export default {
    data() {
      return {
        selectedEntityRelationships: [],
        selectedAllocationEntity: {},
        allocateBasedOnEntity: {},
        entityFieldLoading: false,
        entitiesData: [],
        allocationEntityField: {},
      };
    },
    props: {
      currentEntity: Object,
      allEntities: Array,
      entityAllFilters: Array,
      entityRelationships: Array,
      step: Object,
      companyAllTemplateFields: Object,
    },
    mixins: [StepEditableMixin, EntitiesHelper, CustomDashboardHelper],
    mounted() {
      setTimeout(this.resetData, 100);
    },
    computed: {
      isAssign() {
        return this.localStep.allocationRole === 'Assign';
      },
      isUnassign() {
        return this.localStep.allocationRole === 'Unassign';
      },
      getRelationalEntities() {
        return (
          this.entityRelationships
            ?.filter((rel) => rel.parent_entity_id === this.currentEntity._id)
            .map((e) => this.allEntities.find((ent) => ent._id === e.child_entity_id)) || []
        );
      },
      getAllocationToOptions() {
        if (!this.localStep.allocationEntity) return [];
        const options = [
          {
            label: this.selectedAllocationEntity.name || 'Select Entity',
            value: this.selectedAllocationEntity._id || '',
          },
          ...this.selectedEntityRelationships
            .filter((e) => e.parent_entity_id === this.selectedAllocationEntity._id)
            .map((rel) => ({
              label:
                this.allEntities.find((ent) => ent._id === rel.child_entity_id)?.name ||
                'Unknown Entity',
              value: rel.child_entity_id,
            })),
        ];
        return options;
      },
    },
    methods: {
      resetData() {
        const defaults = {
          label: 'Allocate User',
          resourceEntity: this.currentEntity._id,
          allocationMethod: 'round_robin',
          excludeManual: 'Yes',
          allocationRole: 'Assign',
          allocateTo: '',
        };

        // Using a loop to set missing values
        Object.keys(defaults).forEach((key) => {
          if (!this.localStep[key]) {
            this.$set(this.localStep, key, defaults[key]);
          }
        });

        // Special handling for allocationEntity
        if (!this.localStep.allocationEntity && this.getRelationalEntities.length) {
          console.log('setting allocation entity', this.getRelationalEntities);
          this.$set(this.localStep, 'allocationEntity', this.getRelationalEntities[0]._id);
          this.handleToChange(this.localStep.allocationEntity);
        } else if (this.localStep.allocationEntity) {
          this.handleToChange(this.localStep.allocationEntity, true);
        }
      },

      async handleToChange(value, mounted = false) {
        if (!value) {
          this.selectedEntityRelationships = [];
          return;
        }
        let rel = this.entityRelationships.find((r) => r.child_entity_id === value);
        this.allocationEntityField = Object.values(this.companyAllTemplateFields).find(
          (f) => f._id == rel.field_id
        );
        this.$set(
          this.localStep,
          'selectedAllocationFieldKey',
          this.allocationEntityField?.template_key || ''
        );
        this.selectedAllocationEntity = this.allEntities.find((ent) => ent._id === value) || {};
        this.selectedEntityRelationships = await fetchEntityRelationships({ entity_id: value });
        this.$set(this.localStep, 'allocateBasedOn', this.selectedAllocationEntity._id);
        this.handleAllocateBasedOnChange(this.localStep.allocateBasedOn, mounted);
      },

      handleAllocateBasedOnChange(value, mounted = false) {
        this.$set(this.localStep, 'excludeFilter', '');
        const prevValue = this.allocateBasedOnEntity?._id;
        const isSameEntity = value === this.localStep.allocationEntity;

        this.allocateBasedOnEntity = this.allEntities.find((ent) => ent._id === value) || {};

        const shouldReset = !mounted && prevValue !== value && !isSameEntity;

        if (shouldReset) {
          this.$set(this.localStep, 'allocateTo', isSameEntity ? [] : '');
        }

        this.fetchEntityData();
      },

      async fetchEntityData(query = '') {
        try {
          this.entityFieldLoading = true;
          this.entitiesData =
            (await this.fetchEntitiesDataForTables(
              this.allocateBasedOnEntity,
              1,
              500,
              query,
              [],
              [],
              '',
              null,
              true
            )) || [];
        } catch (err) {
          this.entityFieldLoading = false;
          console.error('Error fetching entity data:', err);
        } finally {
          this.entityFieldLoading = false;
        }
      },

      getLabel(item, i, field = null) {
        const primaryFields = field
          ? field.primary_fields
          : this.allocateBasedOnEntity.primaryFields.map((e) => `${e.template_id}#${e.key}`);

        let name = primaryFields
          .map((pr, index) => {
            const field = this.companyAllTemplateFields?.[pr];
            const primaryName = this.getPrimaryName(field, item);
            if (field && !['DATA_TABLE', 'ENTITY_TABLE'].includes(field.inputType) && primaryName) {
              return `${index > 0 ? ' - ' : ''}${primaryName}`;
            }
            return '';
          })
          .join('');

        return name || `Data ${i}`;
      },
    },
  };
</script>
